import React from 'react';
import Header from "../standartComponents/header";
import css from "./info.module.css";
import Policies from '../standartComponents/policies';
import { useTranslation } from 'react-i18next';

const CancelAndRefund = ({ authUser }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Header authUser={authUser} />
      <div className={css.refundContainer}>
        <div className={css.contentWrapper}>
          <h1 className={css.pageTitle}>{t("Cancellation and Refund Policy")}</h1>
          <span className={css.bottomLine}></span>
          <p className={css.lastUpdated}>{t("Last updated")}: 13 {t("October")} 2025</p>

          <div className={css.section}>
            <p className={css.sectionText}>
              <strong>• {t("Trial period:")}</strong> {t("refund1")}
            </p>
            <p className={css.sectionText}>
              <strong>• {t("Payment and auto-renewal:")}</strong> {t("refund2")}
            </p>
            <p className={css.sectionText}>
              <strong>• {t("CNCL")}</strong> {t("refund3")}
            </p>
            <p className={css.sectionText}>
              <strong>• {t("RFND")}</strong> {t("refund4")}
            </p>
            <p className={css.sectionText}>
              {t("refund5")} <a href="mailto:ailinguaservice@gmail.com">ailinguaservice@gmail.com</a>.
            </p>
          </div>
        </div>
      </div>
      <Policies />
    </div>
  )
}

export default CancelAndRefund;